import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {useDispatch} from "react-redux";
import {navbarToggler} from "../../redux/actions/utilities";

export default function SideMenuItem(props) {
  let { label, to, ...args } = props;
  const dispatch = useDispatch();

  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];


  const navbarToggle = () => {
    toMatch.some((toMatchItem) => {
      if(navigator.userAgent.match(toMatchItem)){
        dispatch(navbarToggler());
      }
    });
  };
  return (
    <NavLink
      className={`km__c--side-menu-item`}
      activeClassName='km__c--side-menu-item-is-active'
      to={to}
      id={`sm-sub-${to.replace('/', '')}`}
      onClick={navbarToggle}
      {...args}
    >
      {label}
    </NavLink>
  );
}

SideMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
};
